import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';

var FavouriteListDialogue = /*#__PURE__*/function (_Component) {
  _inherits(FavouriteListDialogue, _Component);

  var _super = _createSuper(FavouriteListDialogue);

  function FavouriteListDialogue() {
    _classCallCheck(this, FavouriteListDialogue);

    return _super.apply(this, arguments);
  }

  _createClass(FavouriteListDialogue, [{
    key: "_normalizeFavouriteGames",
    value: function _normalizeFavouriteGames() {
      if (this.props.favouriteGames) {
        var favGameList = this.props.favouriteGames.gameList;
        return favGameList.map(function (item) {
          var game = {};
          game.item_id = item.game_id;
          game.item_type = 'game';
          game.isSquare = true;
          game.height = 1;
          game.width = 1;
          return game;
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.render({
        favouriteGames: this._normalizeFavouriteGames()
      });
    }
  }]);

  return FavouriteListDialogue;
}(Component);

export { FavouriteListDialogue as default };